module.exports = __webpack_public_path__ + "static/media/Drug_danger_and_dependence.0ed757bc.png";